import a from "./fonts.css.js";
import n from "./presets/alternate.css2.js";
import p from "./presets/bluePlanet.css2.js";
import f from "./presets/deepSpace.css2.js";
import o from "./presets/default.css2.js";
import i from "./presets/elysiajs.css2.js";
import u from "./presets/fastify.css2.js";
import h from "./presets/kepler.css2.js";
import c from "./presets/mars.css2.js";
import T from "./presets/moon.css2.js";
import d from "./presets/laserwave.css2.js";
import y from "./presets/purple.css2.js";
import b from "./presets/saturn.css2.js";
import S from "./presets/solarized.css2.js";
import { migrateThemeVariables as G } from "@scalar/types/api-reference";
import { hasObtrusiveScrollbars as J } from "./utilities/hasObtrusiveScrollbars.js";
const A = [
  "alternate",
  "default",
  "moon",
  "purple",
  "solarized",
  "bluePlanet",
  "deepSpace",
  "saturn",
  "kepler",
  "elysiajs",
  "fastify",
  "mars",
  "laserwave",
  "none"
], E = {
  default: "Default",
  alternate: "Alternate",
  moon: "Moon",
  purple: "Purple",
  solarized: "Solarized",
  elysiajs: "Elysia.js",
  fastify: "Fastify",
  bluePlanet: "Blue Planet",
  saturn: "Saturn",
  kepler: "Kepler-11e",
  mars: "Mars",
  deepSpace: "Deep Space",
  laserwave: "Laserwave",
  none: ""
}, s = {
  alternate: n,
  default: o,
  moon: T,
  elysiajs: i,
  fastify: u,
  purple: y,
  solarized: S,
  bluePlanet: p,
  deepSpace: f,
  saturn: b,
  kepler: h,
  mars: c,
  laserwave: d
}, I = () => a, K = Object.keys(s), j = (e) => e === "none" ? "" : s[e || "default"] ?? o, V = (e, l) => {
  const { fonts: m = !0, layer: r = "scalar-theme" } = l ?? {}, t = [j(e), m ? a : ""].join("");
  return r ? `@layer ${r} {
${t}}` : t;
};
export {
  n as alternateTheme,
  K as availableThemes,
  p as bluePlanetTheme,
  f as deepSpaceTheme,
  o as defaultTheme,
  i as elysiajsTheme,
  u as fastifyTheme,
  I as getDefaultFonts,
  j as getThemeById,
  V as getThemeStyles,
  J as hasObtrusiveScrollbars,
  h as keplerTheme,
  d as laserwaveTheme,
  c as marsTheme,
  G as migrateThemeVariables,
  T as moonTheme,
  s as presets,
  y as purpleTheme,
  b as saturnTheme,
  S as solarizedTheme,
  A as themeIds,
  E as themeLabels
};
